import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { BaseComponent } from 'src/app/components/base/base.component';
import { AuthService } from '../../services/auth.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { LoginCallbackState } from '../../enums/login-callback-state.enum';


@Component({
  templateUrl: './login-callback.component.html',
  styleUrls: [
    './../../../../../styles.scss',
    './login-callback.component.scss'
  ],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class LoginCallbackComponent extends BaseComponent implements OnInit, OnChanges {
  /** 
    * language URL parameter value, e.g. 'es' 
    * NOT THE SAME AS LANGUAGE KEY
    */
  @Input() language!: string;
  /** 
   * FOR DEVELOPMENT/TESTING PURPOSES
   * false (default) - redirect to a page that was before loging in; 
   * true - stay on login callback page
   */
  @Input() dontRedirectToInitPage: boolean = false;

  view!: string;
  linkJayride!: string;
  linkContactUs!: string;
  linkCookiesPolicy!: string;

  constructor(
    private authService: AuthService,
    protected override environmentService: EnvironmentService,
  ) {
    super(environmentService);
  }

  async ngOnInit() {
    this.defineLinks();
    const loginCallbackState = await this.authService.handleLoginCallback();
    switch (loginCallbackState) {
      case LoginCallbackState.AccountDeleted:
        this.view = 'account-deleted';
        break;
      case LoginCallbackState.EmailNotVerified:
        this.view = 'email-not-verified';
        break;
      case LoginCallbackState.UserEmailExists:
      case LoginCallbackState.UserExists:
        this.view = 'email-exists';
        break;
      case LoginCallbackState.NoErrors:
        this.view = 'no-errors';
        if (!this.dontRedirectToInitPage) {
          this.authService.navigateToInitialPage();
        }
        break;
      case LoginCallbackState.ExchangeCodeError:
        this.view = 'error-code-exchange';
        break;
      case LoginCallbackState.CookiesDisabledError:
        this.view = 'cookie-disabled';
        break;
      case LoginCallbackState.InvalidAccessToken:
      case LoginCallbackState.NoAccessToken:
      case LoginCallbackState.ProfileError:
      case LoginCallbackState.GeneralLoginError:
        this.view = 'error-general';
        break;
      default:
        this.view = 'error-general';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['language']) {
      this.defineLinks();
    }
    if (changes['customEnvironment']) {
      this.defineEnvironment();
    }
  }

  private defineLinks() {
    const jpressLink = this.environmentService.getJpressUrl();
    const langParam = this.language ? `${this.language}/` : '';
    this.linkJayride = `${jpressLink}/${langParam}`;
    this.linkContactUs = `${jpressLink}/${langParam}contact-us/`;
    this.linkCookiesPolicy = `${jpressLink}/${langParam}cookies-policy/`;
  }

  relogin() {
    this.authService.logOut();
    this.authService.logIn();
  }

  onCloseMessage() {
    this.view = LoginCallbackState.NoErrors;
    this.authService.cleanQueryParams();
    if (!this.dontRedirectToInitPage) {
      this.authService.navigateToInitialPage();
    }
  }
}
